import { render, staticRenderFns } from "./RegisterContent.vue?vue&type=template&id=59941ee0"
import script from "./RegisterContent.vue?vue&type=script&lang=ts"
export * from "./RegisterContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports